var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, Fragment, useMemo } from 'react';
import * as styles from './search-dropdown.styles';
import { Menu, Transition } from '@headlessui/react';
import { classNames } from '../../../utils/style-class.utils';
import { Typography } from '../../typography/typography';
import { renderIcon } from '../../../utils/icon-utils';
export function SearchDropDown(_a) {
    var id = _a.id, placeholder = _a.placeholder, label = _a.label, disabled = _a.disabled, options = _a.options, pluralSelectionText = _a.pluralSelectionText, info = _a.info, multiple = _a.multiple, _b = _a.selectedOptions, selectedOptions = _b === void 0 ? [] : _b, onChange = _a.onChange, className = _a.className, displayMenuOverlay = _a.displayMenuOverlay, menuItemClassName = _a.menuItemClassName, menuItemStyle = _a.menuItemStyle, overlayTopOffset = _a.overlayTopOffset, _c = _a.color, color = _c === void 0 ? 'primary' : _c, _d = _a.bgColor, bgColor = _d === void 0 ? 'white' : _d, _e = _a.isFullWidth, isFullWidth = _e === void 0 ? true : _e, preventCloseOnClick = _a.preventCloseOnClick, _f = _a.showSearch, showSearch = _f === void 0 ? false : _f;
    var _g = useState(''), selectedLabel = _g[0], setSelectedLabel = _g[1];
    var _h = useState(false), touched = _h[0], setTouched = _h[1];
    var _j = useState(false), isOpen = _j[0], setIsOpen = _j[1];
    var _k = useState(''), search = _k[0], setSearch = _k[1];
    var onToggleMenu = function () { return setIsOpen(function (prevState) { return !prevState; }); };
    var lowerSearch = search.toLowerCase();
    var filteredList = useMemo(function () {
        return options &&
            options.filter(function (item) { return item.label.toLowerCase().includes(lowerSearch); });
    }, [options, lowerSearch]);
    var menuItems = showSearch ? filteredList : options;
    var isOptionSelected = function (option) {
        var isInSelectedItems = selectedOptions.some(function (selectedOption) {
            return selectedOption.id === option.id;
        });
        return isInSelectedItems;
    };
    var updateSelectedLabel = function (currentSelectedIds, list) {
        if (currentSelectedIds.length > 1) {
            setSelectedLabel("".concat(currentSelectedIds.length, " ").concat(pluralSelectionText || 'Selected'));
        }
        else if (currentSelectedIds.length === 1) {
            var label_1 = selectedLabel;
            if (currentSelectedIds.length > 0) {
                var selectedOption = list.find(function (option) { return option.id === currentSelectedIds[0].id; });
                label_1 = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || placeholder || '';
            }
            setSelectedLabel(label_1);
        }
        else {
            setSelectedLabel(placeholder || '');
        }
    };
    var optionClicked = function (event, option) {
        event.stopPropagation();
        if (option.disabled)
            return;
        if (!touched) {
            setTouched(true);
        }
        var optionSelected = isOptionSelected(option);
        var newSelection = multiple
            ? handleMutlipleItemSelection(option, optionSelected)
            : handleSingleItemSelection(option, optionSelected);
        onChange && onChange(newSelection);
    };
    var handleMutlipleItemSelection = function (option, selected) {
        var newSelectedOptions = __spreadArray([], selectedOptions, true);
        if (selected) {
            var indexOf = newSelectedOptions.findIndex(function (x) { return x.id === option.id; });
            newSelectedOptions.splice(indexOf, 1);
        }
        else {
            newSelectedOptions.push(option);
        }
        updateSelectedLabel(newSelectedOptions, menuItems);
        return newSelectedOptions;
    };
    var handleSingleItemSelection = function (option, selected) {
        if (selected) {
            setSelectedLabel('');
            return [];
        }
        setSelectedLabel(option.label);
        return [option];
    };
    var hasSelectedValue = function () {
        return selectedOptions.length > 0;
    };
    useEffect(function () {
        if (selectedOptions.length > 0) {
            setTouched(true);
        }
        updateSelectedLabel(selectedOptions, menuItems);
    }, [menuItems, selectedOptions]);
    var renderSearchInput = useMemo(function () { return (_jsx("div", __assign({ className: "sticky top-0 z-10 border-b border-gray-200 bg-white p-2" }, { children: _jsx("input", { id: "search-input", placeholder: "Search...", value: search, onBlur: function () {
                setTimeout(function () { return setIsOpen(false); }, 100);
                onToggleMenu;
            }, type: "text", onChange: function (event) { return setSearch(event.target.value); }, onFocus: onToggleMenu, className: "focus:outline-none w-full rounded-md border border-gray-300 px-3 py-2 text-xs text-gray-900 placeholder-gray-600" }) }))); }, [search, placeholder, setIsOpen, touched, onToggleMenu]);
    return (_jsxs("div", __assign({ className: className }, { children: [label && _jsx("label", __assign({ className: styles.label }, { children: label })), _jsx(Menu, __assign({ as: "div", className: isFullWidth ? 'w-full' : '' }, { children: function (_a) {
                    var open = _a.open;
                    return (_jsxs(_Fragment, { children: [_jsxs(Menu.Button, __assign({ id: id, className: classNames(className, styles.getButtonStyles(color, bgColor, open, hasSelectedValue(), touched)), disabled: disabled, onClick: function () {
                                    return isOpen === false ? setIsOpen(true) : setIsOpen(false);
                                } }, { children: [_jsx(Typography, { type: 'help', fontSize: '12', color: open || !hasSelectedValue() || !touched
                                            ? 'textLight'
                                            : 'white', text: selectedLabel || placeholder || '' }), renderIcon(!open ? 'ChevronDownIcon' : 'ChevronUpIcon', styles.getButtonIcon('primary', open, hasSelectedValue()))] })), _jsx(Transition, __assign({ show: preventCloseOnClick ? isOpen : open, as: Fragment, enter: styles.enter, enterFrom: styles.enterFrom, enterTo: styles.enterTo, leave: styles.leave, leaveFrom: styles.leaveFrom, leaveTo: styles.leaveTo }, { children: _jsx("div", __assign({ className: displayMenuOverlay ? styles.overlay(overlayTopOffset) : '', onClick: preventCloseOnClick
                                        ? function (prevState) { return setIsOpen(!prevState); }
                                        : undefined }, { children: _jsxs(Menu.Items, __assign({ className: classNames(styles.menuItems, menuItemClassName, displayMenuOverlay ? 'absolute' : ''), style: __assign({}, menuItemStyle) }, { children: [info && !showSearch && (_jsxs("div", __assign({ className: styles.infoWrapper }, { children: [info.name && (_jsx(Typography, { type: "body", fontSize: '14', color: 'textDark', text: info.name })), info.hint && (_jsx(Typography, { type: "help", fontSize: '12', color: 'textMid', text: info.hint || '' }))] }))), showSearch ? renderSearchInput : null, menuItems &&
                                                menuItems.map(function (item, index) {
                                                    var optionSelected = isOptionSelected(item);
                                                    return (_jsx(Menu.Item, __assign({ as: "div", onClick: function (event) {
                                                            return optionClicked(event, item);
                                                        } }, { children: _jsxs("div", __assign({ className: styles.menuItem }, { children: [renderIcon('CheckCircleIcon', styles.getDropDownIcon(color, optionSelected)), _jsx(Typography, { type: 'body', fontSize: '14', text: item.label, color: optionSelected ? 'textDark' : 'textMid' })] })) }), "drop-down-menu-item-".concat(index)));
                                                })] })) })) }))] }));
                } }))] })));
}
export default SearchDropDown;
//# sourceMappingURL=search-dropdown.js.map